import { render, staticRenderFns } from "./popup-area.vue?vue&type=template&id=31b278ce&scoped=true"
import script from "./popup-area.vue?vue&type=script&lang=js"
export * from "./popup-area.vue?vue&type=script&lang=js"
import style0 from "./popup-area.vue?vue&type=style&index=0&id=31b278ce&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31b278ce",
  null
  
)

export default component.exports